
// React Imports
import React, {useEffect, useRef, useState} from 'react';
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from "@mui/material/Box";
import {InputLabel, Select, Stack} from "@mui/material";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";

// App Imports
import {getPayContractProducts, getContractProductsTopLevel} from "../../ExternalData/Product/ProductClient";
import {changeWork} from "../../Work/workSlice";
import {changeWorkIssuance} from "../workIssuanceSlice";
import {changeWorkQueue} from "../../WorkQueue/workQueueSlice";
import {getVersionInfo} from "../../ContractDataPointValue/ContractDataPointValueClient";


// main function
export default function PaySearchBar() {


// ****************** BEGIN STATES ****************************

    const [selectedProduct, setSelectedProduct] = useState([]);
    const { register, handleSubmit, setValue } = useForm();
    // const {register, handleSubmit} = useForm();
    const [productDropdown, setProductDropdown] = useState([]);
    const [productTopLevelDropdown, setProductTopLevelDropdown] = useState([]);
    const [productValue, setProductValue] = useState([useSelector((state) => state.obligationHierarchySlc.value.myProductId)]);
    const [ versionData, setVersionData] = useState([]);
    const [ versionNumber, setVersionNumber] = useState();

// ****************** END STATES ****************************


// *********************** BEGIN STORE ********************************

    const selectorPaymentGrid = useSelector((state) => state.workIssuanceSlc.value.paymentGridState);
    const selectorFringeGrid = useSelector((state) => state.workIssuanceSlc.value.fringeGridState);
    const selectorTaxGrid = useSelector((state) => state.workIssuanceSlc.value.taxGridState);
    const selectorExpenseGrid = useSelector((state) => state.workIssuanceSlc.value.expenseGridState);

    const selectorSearchProductId = useSelector((state) => state.workIssuanceSlc.value.paySearchProductId);
    const selectorVersionNumber = useSelector((state) => state.workIssuanceSlc.value.versionNumber);
    const selectorVersionMode = useSelector((state) => state.workIssuanceSlc.value.versionMode);
    const selectorVersionStatusId = useSelector((state) => state.workIssuanceSlc.value.versionStatusId);
    const selectorVersionStatusName = useSelector((state) => state.workIssuanceSlc.value.versionStatusName);
    const selectorVersionPeriodEndDate = useSelector((state) => state.workIssuanceSlc.value.versionPeriodEndDate);
    const selectorTestScenarioNumber = useSelector((state) => state.workIssuanceSlc.value.testScenarioNumber );
    const selectorTestScenarioName = useSelector((state) => state.workIssuanceSlc.value.testScenarioName );
    const selectorTestScenarioPropertyId = useSelector((state) => state.workIssuanceSlc.value.testScenarioPropertyId );
    const selectorTestScenarioPropertyName = useSelector((state) => state.workIssuanceSlc.value.testScenarioPropertyName );
    const selectorMatchVersionNumber = useSelector((state) => state.workIssuanceSlc.value.maxVersionNumber);

// ********************** END STORE ********************************


// ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

// ****************** END DISPATCH ****************************


    // ****************** BEGIN FETCH ****************************

    const fetchContractProductsTopLevel = () =>
        getContractProductsTopLevel()

            .then(data => {
                console.log("top Level Product Dropdown Data")
                console.log(data);
                // setItems(data.sort((a, b) => a.name > b.name ? 1 : -1) );
                setProductTopLevelDropdown(data);

            })


    const fetchContractProducts = () =>
        getPayContractProducts()

            .then(data => {
                console.log("product dropdown data")
                console.log(data);
                // setItems(data.sort((a, b) => a.name > b.name ? 1 : -1) );
                setProductDropdown(data);

            })


    const fetchVersionInfo = () => {
        if (!selectorSearchProductId || selectorSearchProductId < 1) return Promise.resolve();

        return getVersionInfo(selectorSearchProductId)

            .then(data => {
                setVersionData(data);

                const maxVersionNumber = data.reduce(
                    (max, item) => Math.max(max, Number(item.versionNumber)),
                    0
                );

                const maxVersion = data.find(
                    d => Number(d.versionNumber) === maxVersionNumber
                );
                setValue('my_version_number', maxVersionNumber, {
                    shouldValidate: true
                });
                dispatchData(changeWorkIssuance({
                    versionNumber: maxVersionNumber,
                    fetchVersionNumber: maxVersionNumber,
                    versionMode: maxVersion?.versionMode ?? "",
                    versionStatusId: maxVersion?.versionStatusId ?? "",
                    versionStatusName: maxVersion?.versionStatusName ?? "",
                    versionPeriodEndDate: maxVersion?.periodEndDate ?? "",
                    testScenarioNumber: maxVersion?.testScenarioNumber ?? "",
                    testScenarioName: maxVersion?.testScenarioName ?? "",
                    testScenarioPropertyId: maxVersion?.testScenarioPropertyId ?? "",
                    testScenarioPropertyName: maxVersion?.testScenarioPropertyName ?? "",
                }));
                //
                // setValue('my_version_number', maxVersionNumber, {
                //     shouldValidate: true
                // });

                return maxVersionNumber;
            });
    };
    // ****************** END FETCH ****************************


    // ******************** BEGIN USE EFFECTS *******************

    // useEffect(() => {
    //     console.log("This is for the top-level product dropdown...");
    //     fetchContractProductsTopLevel();
    // }, []);
    //

    useEffect(() => {
        console.log("This is for the top-level product dropdown...");
        fetchContractProducts();
    }, []);


    useEffect(() => {
        console.log("This is for the version dropdown...");
        fetchVersionInfo();
    }, [selectorSearchProductId]);



    // ******************** END USE EFFECTS *******************


    // ****************** BEGIN CONTROLS ****************************

    const handleClearProductClick = () => {
        setProductValue("");
        dispatchData(changeWorkQueue({
            selectedContractId: 0,
            selectedContractName: null,
            selectedContractLevel: null,
            selectedContractProductId: null,
            selectedContractType: null,
            selectedContractGuild: null,
            selectedContractFailedExpressionCount: null,
            selectedContractFailedFilterCount: null,
            selectedContractInputMissingCount: null,
            selectedContractPropertyId: null,
            selectedContractStatus: null,
            selectedContractDescription: null
        }));
        dispatchData(changeWork({
            propertyId: null,
        expansionDepth: null,
        multiSingle: null,
        maxVersionNumber: null}));

        dispatchData(changeWorkIssuance({paySearchProductId: 0}));
    };

    const handleProductChange = (prod) => {
        // setSelectedProduct(dropdownProducts.target.seriesId);
        dispatchData(changeWorkIssuance({paySearchProductId: prod}));
        console.log("This is for the selected Product in the Pay tabs dropdown list");
        console.log(prod);
        console.log("selectedProduct");
        console.log(productDropdown.filter(productDropdown => productDropdown.id === parseInt(prod)));
        console.log(productDropdown.find(productDropdown => productDropdown.id === parseInt(prod)));
        console.log(productDropdown.find(productDropdown => productDropdown.id === parseInt(prod)).expansionDepth);
        dispatchData(changeWork({propertyId: productDropdown.find(productDropdown => productDropdown.id === parseInt(prod)).id,
            expansionDepth: productDropdown.find(productDropdown => productDropdown.id === parseInt(prod)).expansionDepth,
            multiSingle: productDropdown.find(productDropdown => productDropdown.id === parseInt(prod)).multiSingle,
            maxVersionNumber: productDropdown.find(productDropdown => productDropdown.id === parseInt(prod)).maxVersionNumber}));
        setSelectedProduct(productDropdown.find(productDropdown => productDropdown.id === parseInt(prod)));
        console.log(productDropdown[0]);
        // console.log(productDropdown.filter(productDropdown => productDropdown.productId === data.my_product_id));
    };



    const handleVersionChange = (ver) => {
        // setSelectedProduct(dropdownProducts.target.seriesId);
        dispatchData(changeWorkIssuance({versionNumber: ver}));
        console.log("This is for the selected Version from the calc tabs dropdown");
        console.log(ver);
        console.log("selectorVersionNumber", selectorVersionNumber, typeof selectorVersionNumber);
        console.log(
            "versionData values",
            versionData.map(v => [v.versionNumber, typeof v.versionNumber])
        );

        const versionMode = versionData.find(
            d => d.versionNumber === ver
        )?.versionMode ?? "";

        const versionStatusId = versionData.find(
            d => d.versionNumber === ver
        )?.versionStatusId ?? "";

        const versionStatusName = versionData.find(
            d => d.versionNumber === ver
        )?.versionStatusName ?? "";

        const periodEndDate = versionData.find(
            d => d.versionNumber === ver
        )?.periodEndDate ?? "";

        const scenarioNumber = versionData.find(
            d => d.versionNumber === ver
        )?.testScenarioNumber ?? "";

        const scenarioName = versionData.find(
            d => d.versionNumber === ver
        )?.testScenarioName ?? "";

        const scenarioPropertyId = versionData.find(
            d => d.versionNumber === ver
        )?.testScenarioPropertyId ?? "";

        const scenarioPropertyName = versionData.find(
            d => d.versionNumber === ver
        )?.testScenarioPropertyName ?? "";

        dispatchData(changeWorkIssuance({
            versionMode: versionMode,
            versionStatusId: versionStatusId,
            versionStatusName: versionStatusName,
            periodEndDate: periodEndDate,
            testScenarioNumber : scenarioNumber,
            testScenarioName : scenarioName,
            testScenarioPropertyId : scenarioPropertyId,
            testScenarioPropertyName : scenarioPropertyName,
        }));

    };



    function onSubmit(data) {
        const submittedVersionNumber = Number(
            selectorVersionNumber || data.my_version_number
        );

        console.log("fetchProductId to submit:", Number(selectorSearchProductId));
        console.log("fetchVersionNumber to submit:", submittedVersionNumber);

        dispatchData(changeWorkIssuance({
            fetchProductId: Number(selectorSearchProductId),
            fetchVersionNumber: submittedVersionNumber,
            paymentGridRefresh: selectorPaymentGrid === true,
            fringeGridRefresh: selectorFringeGrid === true,
            taxGridRefresh: selectorTaxGrid === true,
            expenseGridRefresh: selectorExpenseGrid === true,
        }));
    }


    // ****************** END CONTROLS ****************************


    // ****************** BEGIN FORM ****************************

    const searchForm  = () => (
        <form

            onSubmit={handleSubmit((data)=>onSubmit(data))}
        >
            <Box
                sx={{ width: 800 , height: 60, pl: 1}}
                role="presentation"
            >


                <Stack direction={"row"} spacing={2}>

                    <Box >
                        <FormControl variant="standard" sx={{ m: 1, minWidth: 500 }}>
                            <InputLabel htmlFor="contractProduct.id"  onClick={handleClearProductClick}>Property</InputLabel>
                            <Select
                                {...register('my_product_id', { required: true })}
                                isClearable={true}
                                id="my_product_id"
                                onChange={(newProductValue) => {
                                    setProductValue(newProductValue.target.value);
                                    console.log(newProductValue.target.value);
                                    handleProductChange(newProductValue.target.value);

                                }}

                                defaultValue=  {productValue}
                                value = {productValue}
                            >
                                {productDropdown.map((productItem) =>
                                    <MenuItem value={productItem.id}>{productItem.seasonName} {productItem.name}</MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    </Box>
                        {selectorSearchProductId > 0 &&  <Box sx={{ width: 70 }}/>}
                        {selectorSearchProductId > 0 &&
                            <Box >
                                    <Box sx={{ width: 70 }}/>
                                <FormControl variant="standard" sx={{ m: 1, minWidth: 200 }}>
                                    <InputLabel id="my_version_number_label"
                                        // onClick={handleClearProductClick}
                                    >Calc Version</InputLabel>
                                    {/*<Select*/}
                                    {/*    {...register('my_version_number', { required: true })}*/}
                                    {/*    isClearable={true}*/}
                                    {/*    labelId="my_version_number_label"*/}
                                    {/*    id="my_version_number"*/}
                                    {/*    onChange={(newVersionData) => {*/}
                                    {/*        setVersionNumber(newVersionData.target.value);*/}
                                    {/*        console.log(newVersionData.target.value);*/}
                                    {/*        handleVersionChange(newVersionData.target.value);*/}

                                    {/*    }}*/}
                                    {/*    // type= "submit"*/}
                                    {/*    // defaultValue=  {productValue}*/}
                                    {/*    value = {selectorVersionNumber}*/}
                                    {/*>*/}
                                        <Select
                                            {...register('my_version_number', { required: true })}
                                            labelId="my_version_number_label"
                                            id="my_version_number"
                                            value={selectorVersionNumber ?? ""}
                                            onChange={(newVersionData) => {
                                                const selectedVersionNumber = Number(newVersionData.target.value);
                                                handleVersionChange(selectedVersionNumber);
                                            }}
                                        >
                                            {versionData.map((versionItem) => (
                                                <MenuItem
                                                    key={versionItem.versionNumber}
                                                    value={Number(versionItem.versionNumber)}
                                                >
                                                    {versionItem.periodEndDate} {versionItem.versionStatusName} {versionItem.versionMode} {versionItem.testScenarioNumber}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    {/*    {versionData.map((versionItem) =>*/}
                                    {/*        <MenuItem value={versionItem.versionNumber}>{versionItem.periodEndDate} {versionItem.versionStatusName} {versionItem.versionMode} {versionItem.testScenarioNumber}</MenuItem>*/}
                                    {/*    )}*/}
                                    {/*</Select>*/}
                                </FormControl>

                            </Box>
                        }
                        <Box>
                    </Box>
                    <Button
                        type= "submit"
                    >Retrieve</Button>
                </Stack>
            </Box>

        </form>
    );

    // ****************** END FORM ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            {searchForm()}
        </div>

    )

    // ****************** END RETURN ****************************


}

